import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import Harvest from "../Harvest/Harvest.js";
import Bucking from "./Bucking.js";

const PostHarvestLogs = () => {
  const [contentTab, setContentTab] = useState(0);

  const tabsSx = {
    backgroundColor: "#fffffc",
    "& .MuiTabs-indicator": {
      backgroundColor: "#00A272",
      height: "3px",
    },
    "& .MuiTab-root": {
      position: "relative",
      color: "#A1A2A1",
      fontWeight: 400,
      fontSize: "16px",
      textTransform: "none",
      padding: "12px 20px",
      marginRight: "8px",
      "&:not(.Mui-selected)::after": {
        content: '""',
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "3px",
        backgroundColor: "#C4C4C4",
      },
      "&.Mui-selected": {
        color: "#00A272 !important",
        fontWeight: 600,
        backgroundColor: "#E6F6F1",
        borderRadius: "4px 4px 0 0",
      },
    },
  };

  return (
    <div className="company">
      <div className="page-title">
        <div className="title-wrap">
          <h1>Post Harvest Logs</h1>
        </div>
      </div>

      <div className="common_content">
        <Tabs
          value={contentTab}
          onChange={(e, newValue) => setContentTab(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{ ...tabsSx, mb: 3 }}
        >
          <Tab label="Harvest" />
          <Tab label="Bucking" />
          <Tab label="Trimming" />
          <Tab label="Inventory" />
          <Tab label="Quarantine" />
        </Tabs>

        {contentTab === 0 && <Harvest hideHeader={true} />}
        {contentTab === 1 && <Bucking />}
        {contentTab === 2 && (
          <div className="placeholder-content" style={{ padding: "40px 20px", textAlign: "center", background: "#fff", borderRadius: "8px", border: "1px solid #E0E0E0" }}>
            <h3>Trimming</h3>
            <p style={{ color: "#888", marginTop: "8px" }}>This section is currently under development.</p>
          </div>
        )}
        {contentTab === 3 && (
          <div className="placeholder-content" style={{ padding: "40px 20px", textAlign: "center", background: "#fff", borderRadius: "8px", border: "1px solid #E0E0E0" }}>
            <h3>Inventory</h3>
            <p style={{ color: "#888", marginTop: "8px" }}>This section is currently under development.</p>
          </div>
        )}
        {contentTab === 4 && (
          <div className="placeholder-content" style={{ padding: "40px 20px", textAlign: "center", background: "#fff", borderRadius: "8px", border: "1px solid #E0E0E0" }}>
            <h3>Quarantine</h3>
            <p style={{ color: "#888", marginTop: "8px" }}>This section is currently under development.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostHarvestLogs;
